<div class="sticky top-[-1px] z-50 w-full mb-4">
  <div class="flex justify-center">
    <div
      class="flex rounded-br-2xl rounded-bl-2xl shadow-lg border border-t-0 border-gray-200/50 p-4 gap-1 w-full justify-center backdrop-blur-xs bg-white/80"
    >
      @for (category of categories; track category) {
        <button
          (click)="selectCategory(category)"
          [class]="
            isActive(category)
              ? 'px-5 py-3 rounded-full text-sm font-medium bg-gradient-to-r from-[rgb(197,164,223)] to-[rgb(235,100,100)] text-white shadow-md will-change-transform transition-transform duration-200 ease-out scale-105'
              : 'px-5 py-3 rounded-full text-sm font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-50 hover:scale-105 will-change-transform transition-transform duration-200 ease-out'
          "
          type="button"
        >
          {{ category }}
        </button>
      }
    </div>
  </div>
</div>
